let mydata={islogin:"N"};
export const appReducer=(state=mydata,action)=>
{
    if(action.type=="setLogin")
    {
        return {...state,islogin:action.value};
    }
    else
        return state;
};
